import { useSnackbar } from "~/components/snackbar/use-snackbar.hook";

export const REORDER_POPUP_AUTO_DISMISS_MS = 10_000;

export function useReorderPopupSnackbar(
	sessionKey: string,
	onAutoDismiss?: () => void,
) {
	return useSnackbar({
		sessionKey,
		autoDismissMs: REORDER_POPUP_AUTO_DISMISS_MS,
		isRetriggerable: true,
		onAutoDismiss,
	});
}
